import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { url } from '../helpers/url';
import { SharedSettings } from '../models/shared-settings';

import { WeeklyAllocationMetric } from '../models/weekly-allocation-metric';
import { WeeklyAllocationGoal } from '../models/weekly-allocation-goal';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class WeeklyAllocationsService {
    constructor(private http: HttpClient, private settings: SharedSettings) { }

    GetMetricForDateAsync(subinventoryId: number, metricId: number, date: DateTime): Observable<WeeklyAllocationGoal> {
        return this.http.get<WeeklyAllocationGoal>(
            this.settings.apiBaseUrl
                + url`WeeklyAllocationGoal?subinventoryId=${subinventoryId}&metricId=${metricId}&date=${date.toISODate()}`);
    }

    GetAllAllocationsActiveInWeeks(
        siteId: string, subinventoryId: number,
        startYear: number, startMonth: number, startWeek: number,
        endYear: number, endMonth: number, endWeek: number): Observable<WeeklyAllocationMetric[]> {

        return this.http.get<WeeklyAllocationMetric[]>(
            this.settings.apiBaseUrl + url`WeeklyAllocationGoal/InRange?siteId=${siteId}&subinventoryId=${subinventoryId}&startYear=${startYear}&startMonth=${startMonth}&startWeek=${startWeek}&endYear=${endYear}&endMonth=${endMonth}&endWeek=${endWeek}`);
    }

    SaveAllocationGoal(goal: WeeklyAllocationGoal): Observable<WeeklyAllocationGoal> {
        var g = Object.assign({}, goal);
        delete g.parent;

        g.id ??= 0;

        return this.http.put<WeeklyAllocationGoal[]>(
            this.settings.apiBaseUrl + url`WeeklyAllocationGoal`, [ g ]).pipe(map(g => g[0]));
    }

    DeleteAllocationGoal(id: number): Observable<void> {
        return this.http.delete<void>(this.settings.apiBaseUrl + url`WeeklyAllocationGoal/${id}`);
    }
}
